import React, { useState, useRef } from 'react';
import * as _ from 'lodash';
// utilities
import _slideLoader from '../../utilities/slideLoader';
import { USER_ROLES } from '../../utilities/constants';
import { useFetchDataWithToken } from '../../utilities/useFetchData';

// components
import Auth from '../Auth';
import { CheckCircleIcon } from '../icons/CheckCircleIcon';
import LwTalkroomCantSettingsModal from './LwTalkroomCantSettingsModal';
import LwUnconnectingModal from './LwUnconnectingModal';

// services
import { LwApiSettings } from '../../services/LwApiSettings'; // LINE WORKS API設定詳細取得API
import LwGroupApi from '../../services/LwGroupApi';
import SessionStorageService from '../../services/utilities/SessionStorageService';

// pages
import { useGetVw } from '../../pages/ExternalServiceCooperation';

export default function InUseContents() {
  const [
    isShowTalkroomCantSettingsModal,
    setIsShowTalkroomCantSettingsModal,
  ] = useState(false);
  const [isShowUnconnectingModal, setIsShowUnconnectingModal] = useState(false);

  const fieldId = SessionStorageService.getFieldId();
  const lwApiSettingId = useGetLwApiSettingId(fieldId);
  const vw = useGetVw();
  const isSending = useRef(false);

  return (
    <React.Fragment>
      <CheckCircleIcon className='icon--2_4x ExternalServiceCooperation__contents-status-icon--cooperated' />
      <div className='ExternalServiceCooperation__contents-status ExternalServiceCooperation__contents-status--cooperated'>
        連携済
      </div>
      <div className='ExternalServiceCooperation__contents-btn-group'>
        <Auth approvedRoles={[USER_ROLES.prime, USER_ROLES.branch]}>
          <div className='ExternalServiceCooperation__contents-btn'>
            <button
              className='btn--sub'
              onClick={() => {
                if (isSending.current) {
                  return;
                }
                isSending.current = true;
                moveLwApiSettingRegister(lwApiSettingId, vw);
                isSending.current = false;
              }}
            >
              連携情報の更新
            </button>
          </div>
          <div className='ExternalServiceCooperation__contents-btn'>
            <button
              className='btn--negative'
              onClick={() => setIsShowUnconnectingModal(true)}
            >
              連携解除
            </button>
          </div>
        </Auth>
        <div className='ExternalServiceCooperation__contents-btn--last'>
          <button
            className='btn--stay'
            onClick={() => {
              if (isSending.current) {
                return;
              }
              isSending.current = true;
              moveLwGroups(lwApiSettingId);
              isSending.current = false;
            }}
          >
            グループの設定
          </button>
        </div>
        <div className='ExternalServiceCooperation__contents-btn'>
          <button
            className='btn--stay'
            onClick={() => {
              if (isSending.current) {
                return;
              }
              isSending.current = true;
              moveLwTalkrooms(
                lwApiSettingId,
                fieldId,
                setIsShowTalkroomCantSettingsModal
              );
              isSending.current = false;
            }}
          >
            トークルームの設定
          </button>
        </div>
      </div>
      <LwTalkroomCantSettingsModal
        visible={isShowTalkroomCantSettingsModal}
        setVisible={setIsShowTalkroomCantSettingsModal}
      />
      <LwUnconnectingModal
        visible={isShowUnconnectingModal}
        setVisible={setIsShowUnconnectingModal}
        lwApiSettingId={lwApiSettingId}
      />
    </React.Fragment>
  );
}

/**
 * @description LINE WORKS APIの設定IDを取得する
 */
function useGetLwApiSettingId(fieldId) {
  const { data } = useFetchDataWithToken(
    LwApiSettings.list.get_options(fieldId),
    {}
  );
  const lwApiSettings = _.get(data, 'data.entities.lw_api_settings', []);
  const lwApiSetting = _.find(lwApiSettings, item => {
    return item.field_id === Number(fieldId);
  });

  return !_.isUndefined(lwApiSetting) ? lwApiSetting.id : 0;
}

/**
 * @description LINE WORKS 連携情報登録/詳細・編集 画面へ遷移
 */
function moveLwApiSettingRegister(lwApiSettingId, vw) {
  _slideLoader.show(
    'LwApiSettingRegister',
    {
      state: { id: lwApiSettingId },
    },
    vw
  );
}

/**
 * @description LINE WORKS グループ一覧 画面へ遷移
 */
function moveLwGroups(lwApiSettingId) {
  _slideLoader.show('LwGroups', {
    state: { id: lwApiSettingId },
  });
}

/**
 * @description LINE WORKS トークルーム一覧 画面へ遷移
 */
async function moveLwTalkrooms(
  lwApiSettingId,
  fieldId,
  setIsShowDialogTalkroomError
) {
  const lwGroupId = await getCurrentLwGroupId(fieldId);
  if (_.isNumber(lwGroupId)) {
    _slideLoader.show('LwTalkrooms', {
      state: { id: lwApiSettingId, lwGroupId },
    });
  } else {
    setIsShowDialogTalkroomError(true);
  }
}

async function getCurrentLwGroupId(fieldId) {
  let lwGroupId = null;
  const { result, data } = await LwGroupApi.current_user_belonged_lw_group(
    fieldId
  );
  if (!result || data.total <= 0) {
    return lwGroupId;
  }
  lwGroupId = _.get(data, 'entities.lw_group.id', '');
  if (!_.isNumber(lwGroupId)) {
    lwGroupId = null;
  }
  return lwGroupId;
}



// WEBPACK FOOTER //
// ./src/components/externalService/LwInUseContents.jsx